import React from "react";
import styles from "../styles.module.css"

export function DisplayPlayer(props: {name: string, small?: boolean}) {
    return <button className={`${styles.NaamWeergave} ${props.small ? styles.Klein : ''}`}>
        {props.name}
    </button>
}